import { types } from "../../../types";

const initialState = {
    // pagination: {
    //     data: [],
    //     per_page: 10
    // },
    // list: [],
    active: null,
    activeId: null,
    openForm: false,
    grades: [],
    classLoadReport: null,
};

export const scheduleReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.scheduleEmployeeSetActive:
            return {
                ...state,
                active: action.payload,
            };
        case types.scheduleEmployeeUnsetActive:
            return {
                ...state,
                active: null,
            };
        case types.scheduleEmployeeSetActiveId:
            return {
                ...state,
                activeId: action.payload,
            };
        case types.scheduleEmployeeUnsetActiveId:
            return {
                ...state,
                activeId: null,
            };
        case types.setGradesByGroup:
            return {
                ...state,
                grades: action.payload,
            };
        case types.UnSetGradesByGroup:
            return {
                ...state,
                grades: [],
            };
        case types.setClassLoadReport:
            return {
                ...state,
                classLoadReport: action.payload,
            };
        default:
            return state;
    }
};
